import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FONTS_URL =
  "https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap";

function useFonts() {
  useEffect(() => {
    if (document.querySelector('link[href*="Instrument+Serif"]')) return;
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = FONTS_URL;
    document.head.appendChild(l);
  }, []);
}

const T = {
  g700: "#155c36", g600: "#1b7a47", g500: "#1e9254", g400: "#28b566",
  g200: "#a7d9bc", g100: "#d6f0e3", g50: "#eef8f3",
  n900: "#0f1117", n800: "#1c2130", n700: "#2d3549", n600: "#4a5268",
  n400: "#8a93a8", n300: "#b0b8cc", n200: "#d1d5e0", n150: "#e4e7ef",
  n100: "#eef0f5", n50: "#f7f8fa", white: "#ffffff",
  amber: "#d97706", amberBg: "#fffbeb", amberBorder: "#fde68a",
  serif: "'Instrument Serif', Georgia, serif",
  sans: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
};

const Icon = ({ name, size = 20, color = "currentColor", strokeWidth = 1.6 }) => {
  const paths = {
    ArrowLeft:    <><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></>,
    ArrowRight:   <><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></>,
    Search:       <><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></>,
    MapPin:       <><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="3"/></>,
    Star:         <><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></>,
    CheckCircle:  <><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></>,
    ShieldCheck:  <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></>,
    BadgeCheck:   <><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><path d="m9 12 2 2 4-4"/></>,
    Camera:       <><path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"/><circle cx="12" cy="13" r="3"/></>,
    Image:        <><rect width="18" height="18" x="3" y="3" rx="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/></>,
    Users:        <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>,
    Clock:        <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>,
    Wallet:       <><path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"/><path d="M3 5v14a2 2 0 0 0 2 2h16v-5"/><path d="M18 12a2 2 0 0 0 0 4h4v-4Z"/></>,
    Briefcase:    <><rect width="20" height="14" x="2" y="7" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></>,
    Calendar:     <><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></>,
    Sparkles:     <><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3z"/></>,
    Download:     <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></>,
    Zap:          <><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></>,
    Heart:        <><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></>,
    Film:         <><rect width="20" height="20" x="2" y="2" rx="2.18"/><line x1="7" y1="2" x2="7" y2="22"/><line x1="17" y1="2" x2="17" y2="22"/><line x1="2" y1="12" x2="22" y2="12"/><line x1="2" y1="7" x2="7" y2="7"/><line x1="2" y1="17" x2="7" y2="17"/><line x1="17" y1="17" x2="22" y2="17"/><line x1="17" y1="7" x2="22" y2="7"/></>,
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      {paths[name]}
    </svg>
  );
};

/* ══ DATA ══ */

const SUB_SERVICES = [
  {
    icon: "Heart",
    label: "Wedding and Engagement Photography",
    desc: "Full-day or half-day wedding coverage from getting-ready shots through to the reception. Engagement sessions for save-the-date content, proposals, and pre-wedding portraits. Photographers on JiraniApp bring professional camera bodies, lenses, and lighting rigs and deliver edited galleries within an agreed turnaround.",
    range: "KES 15,000 – 80,000",
    note: "per event",
    tags: ["Full-day coverage", "Engagement sessions", "Edited gallery", "Lighting setup"],
  },
  {
    icon: "Users",
    label: "Portrait and Family Photography",
    desc: "Family portraits, individual headshots, maternity shoots, newborn sessions, and milestone portraits for children. Sessions can take place at your home, in your garden, or at an outdoor location of your choosing. Photographers guide posing and expressions throughout so you do not need prior experience in front of a camera.",
    range: "KES 5,000 – 20,000",
    note: "per session",
    tags: ["Family portraits", "Maternity", "Newborn", "Headshots", "Milestones"],
  },
  {
    icon: "Briefcase",
    label: "Corporate and Event Photography",
    desc: "Coverage for corporate events, conferences, product launches, award ceremonies, team days, and office environments. Deliverables include edited high-resolution images ready for press, social media, and internal communications, with a clear agreed turnaround time and usage rights.",
    range: "KES 8,000 – 40,000",
    note: "per event",
    tags: ["Corporate events", "Conferences", "Product launches", "Team photos"],
  },
  {
    icon: "Image",
    label: "Product and Commercial Photography",
    desc: "Studio-quality product photography for e-commerce, marketing campaigns, menus, and brand content. Photographers bring portable studio setups including backdrops, softboxes, and reflectors. Ideal for fashion items, food, jewellery, electronics, and packaged goods.",
    range: "KES 3,000 – 25,000",
    note: "per session",
    tags: ["E-commerce", "Food photography", "Jewellery", "Fashion", "Brand content"],
  },
  {
    icon: "Sparkles",
    label: "Social Media and Content Photography",
    desc: "Lifestyle shoots, influencer content, personal branding sessions, and social media content creation for individuals and small businesses. Photographers understand platform requirements and shoot with aspect ratios, cropping, and content variety in mind for Instagram, LinkedIn, and other channels.",
    range: "KES 4,000 – 15,000",
    note: "per session",
    tags: ["Instagram content", "Personal branding", "Lifestyle", "Influencer shoots"],
  },
  {
    icon: "Film",
    label: "Videography and Reels",
    desc: "Short-form video content for social media, event highlight reels, property walkthroughs, and corporate films. Many photographers on JiraniApp also shoot and edit video. Packages include filming, editing, colour grading, and delivery of final files in agreed formats.",
    range: "KES 10,000 – 60,000",
    note: "per project",
    tags: ["Event reels", "Social media video", "Property tours", "Corporate films"],
  },
];

const HOW_IT_WORKS = [
  {
    n: "01",
    icon: "Search",
    title: "Search by photography type and location",
    desc: "Enter the type of photography you need and your area. JiraniApp shows you verified photographers near you who list that specific style, with their portfolio visible on their profile before you book. You can filter by price range, rating, and availability to narrow results to what fits your brief and budget.",
    detail: "Photographers on JiraniApp each have a distinct style. Some shoot with a documentary, candid approach while others work with more directed, posed compositions. Browsing portfolios before booking is the most reliable way to confirm a photographer's aesthetic matches what you have in mind for your shoot.",
  },
  {
    n: "02",
    icon: "Image",
    title: "Review their portfolio and discuss your brief",
    desc: "Every photographer's profile includes a portfolio of their actual work, client reviews from real bookings, their full service menu with pricing, and their equipment list. Message them before confirming to share your brief, location preferences, mood board references, and any specific shots you have in mind. Photographers appreciate clarity upfront and use this to prepare properly for your session.",
    detail: "The pre-booking conversation is important for photography more than most services. Confirming the shoot location in advance, discussing whether artificial lighting is needed, agreeing on the number of final edited images included, and clarifying turnaround time for delivery all prevent misunderstandings on the day.",
  },
  {
    n: "03",
    icon: "Calendar",
    title: "Book your session and confirm the details",
    desc: "Pick your date and time, add the shoot location or address, and note any specific requirements such as outfit changes, multiple locations, drone usage, or video alongside stills. The photographer confirms the booking and you will receive a reminder before the session. For weddings and large events, most photographers prefer to book at least four to six weeks in advance.",
    detail: "For events and weddings, your booking notes serve as the brief the photographer works from on the day. The more detail you include about the schedule, key moments, and must-have shots, the more prepared they will be. You can also share a shot list through in-app messaging after booking.",
  },
  {
    n: "04",
    icon: "Camera",
    title: "The shoot happens",
    desc: "Your photographer arrives at the agreed location with professional equipment suited to the session type. For studio-style product or portrait shoots, they bring their own lighting and backdrops. For events and outdoor sessions, they work with available light and supplementary equipment as needed. They guide you through the session so you know what to do and when.",
    detail: "If weather affects an outdoor shoot or circumstances change on the day, you can communicate with your photographer through the app and adjust the plan. Most photographers are flexible within reason and will work with you to get the best possible outcome from the conditions.",
  },
  {
    n: "05",
    icon: "Download",
    title: "Receive your edited images",
    desc: "After the session, your photographer edits and delivers the final images within the agreed turnaround time, which is set before booking and visible on their profile. Deliverables are shared digitally via a download link or cloud gallery. You pay through JiraniApp once you have confirmed delivery of the final images, not when the shoot ends.",
    detail: "Turnaround times vary by photographer and session type. Portrait sessions are typically delivered within three to seven days. Wedding galleries typically take two to four weeks. Commercial and product photography timelines depend on the volume and are agreed before the shoot. These should all be confirmed in the booking conversation.",
  },
];

const TRUST_POINTS = [
  {
    icon: "BadgeCheck",
    title: "Verified identity, visible portfolio",
    desc: "Every photographer on JiraniApp is identity-verified before going live. Their profile portfolio shows their actual work so you can assess style, quality, and consistency before you book. What you see in the portfolio is what you are hiring.",
  },
  {
    icon: "Star",
    title: "Reviews only from completed, paid bookings",
    desc: "Every review on a photographer's profile was left by a client who completed and paid for a session through JiraniApp. You cannot leave a review without a real booking. Ratings reflect genuine client experiences across real shoots, not self-promotion or third-party testimonials.",
  },
  {
    icon: "Wallet",
    title: "Payment held until final delivery confirmed",
    desc: "For photography specifically, your payment is held securely and only released to the photographer once you confirm receipt of your final edited images. You are not paying upfront and hoping the delivery follows. The photographer gets paid when the job is done and you are satisfied.",
  },
  {
    icon: "ShieldCheck",
    title: "Jirani Guarantee on every booking",
    desc: "If a photographer cancels last minute, does not arrive, or delivers work that is materially different from their profile portfolio and what was agreed, you are covered under the Jirani Guarantee. Raise a dispute within 48 hours and our Trust and Safety team reviews both sides and works toward a fair resolution.",
  },
];

const TESTIMONIALS = [
  {
    name: "Priya K.",
    area: "Lavington, Nairobi",
    service: "Wedding photography",
    rating: 5,
    text: "We booked our wedding photographer through JiraniApp after spending weeks looking elsewhere with no luck finding someone whose style matched what we wanted. Her portfolio on the platform was exactly the aesthetic we were going for. She was at the venue before we arrived, captured everything we asked for and several moments we did not even think to ask for, and delivered a full gallery within three weeks. Every single image is beautiful. We cannot thank her enough.",
  },
  {
    name: "Kevin O.",
    area: "Westlands, Nairobi",
    service: "Product photography for e-commerce",
    rating: 5,
    text: "I run a small clothing label and I needed proper product photography for my website launch. I had been using my phone and the results were fine but not professional. The photographer I found on JiraniApp came to my studio space with a full portable lighting setup, a clean backdrop, and a structured approach. We shot 40 items in three hours and the edited images were delivered within four days. My conversion rate on the site has gone up noticeably since switching to professional photos.",
  },
  {
    name: "Achieng B.",
    area: "Kilimani, Nairobi",
    service: "Maternity and newborn portrait session",
    rating: 5,
    text: "I was nervous about a maternity shoot because I had never done one before and did not know what to expect. The photographer I found through JiraniApp was incredibly patient, gave clear direction the whole time, and made the whole experience feel natural rather than forced. She came to our home, used the natural light from our living room window, and the images she delivered are exactly what I wanted to remember this time with. We have already rebooked her for our newborn session.",
  },
];

const FAQS = [
  {
    q: "How many edited images will I receive after my session?",
    a: "This varies by photographer and is always specified on their profile and confirmed before you book. Portrait and family sessions typically include 30 to 60 edited images. Half-day event coverage might deliver 100 to 200. Wedding full-day coverage commonly delivers 400 to 800 edited images. Product photography is often priced per image or per batch. Always confirm the exact number of final deliverables in your pre-booking conversation with the photographer so there are no misunderstandings after the shoot.",
  },
  {
    q: "What is included in the editing and how much retouching is done?",
    a: "Standard editing on JiraniApp includes colour correction, exposure and contrast adjustments, and basic skin smoothing where relevant. Heavy retouching such as body reshaping, background replacement, or composite editing may be offered as an add-on and should be discussed before booking. Each photographer's profile describes their editing style and what is included in their base rate. If you have specific retouching requests, mention them before booking so the photographer can confirm whether they are included or quoted separately.",
  },
  {
    q: "Do I own the images after the shoot?",
    a: "For personal sessions such as family portraits, weddings, and personal branding shoots, you receive full personal usage rights to the images. For commercial shoots, usage rights vary and should be agreed before booking. Commercial photographers typically license images for specific uses such as online advertising, print, or social media, and fees reflect the scope of usage. If you are booking for commercial purposes, clarify the intended usage in your pre-booking conversation and confirm the licence terms before you confirm the booking.",
  },
  {
    q: "Can I request a specific location for the shoot?",
    a: "Yes. Most photographers on JiraniApp are comfortable shooting at a location of your choosing, whether that is your home, garden, a park, a rented studio space, or a specific landmark. Mention the location when booking so the photographer can confirm they are comfortable with it and can plan their equipment and lighting approach accordingly. For locations that require permits or entry fees, these are typically the client's responsibility unless agreed otherwise in advance.",
  },
  {
    q: "What happens if the weather is bad on the day of an outdoor shoot?",
    a: "This is worth discussing with your photographer before the session. Most photographers are flexible about rescheduling outdoor sessions due to bad weather, particularly for portrait and family shoots. For events where the date cannot change, photographers adapt to conditions. If you need to reschedule, do so through the app as early as possible. Rescheduling policies vary by photographer and are worth confirming before you book, especially for time-sensitive shoots.",
  },
  {
    q: "How far in advance should I book for a wedding or large event?",
    a: "For weddings, booking four to six months in advance is strongly recommended. The best-reviewed and most sought-after wedding photographers on JiraniApp fill their calendars quickly, particularly for peak seasons around December, August, and major holidays. For corporate events, four to six weeks is typically sufficient. For portrait and product sessions, one to two weeks notice is usually enough, though popular photographers may have waitlists on weekends.",
  },
  {
    q: "Can the photographer also shoot video or reels for social media?",
    a: "Many photographers on JiraniApp also offer videography and short-form video content creation. This is listed as a separate service on their profile. If you want both stills and video from the same shoot, confirm this before booking as it affects the equipment the photographer brings and the time required. Some photographers work with a dedicated videographer for larger events, while others handle both disciplines themselves for shorter sessions.",
  },
  {
    q: "What if I am not happy with the final images?",
    a: "Raise a dispute within 48 hours of receiving your gallery through Help and Support. Describe the specific issue and include examples of what you expected based on the photographer's portfolio or your agreed brief. Our Trust and Safety team reviews the booking notes, the agreed brief, and the delivered work to assess whether the delivery matched what was agreed. Where a photographer has materially under-delivered relative to what was booked, we work toward a fair resolution including partial or full refunds.",
  },
];

/* ── Sub-components ── */

function StarRating({ count = 5 }) {
  return (
    <div style={{ display: "flex", gap: 2 }}>
      {Array.from({ length: count }).map((_, i) => (
        <svg key={i} width="13" height="13" viewBox="0 0 24 24" fill={T.amber} stroke={T.amber} strokeWidth="1">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
        </svg>
      ))}
    </div>
  );
}

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ borderBottom: `1px solid ${T.n100}` }}>
      <button onClick={() => setOpen(o => !o)} style={{
        width: "100%", textAlign: "left", background: "none", border: "none",
        padding: "22px 0", display: "flex", justifyContent: "space-between",
        alignItems: "center", cursor: "pointer", gap: 20, fontFamily: T.sans,
      }}>
        <span style={{ fontSize: 15, fontWeight: 400, color: T.n800, lineHeight: 1.5, letterSpacing: "-0.01em" }}>{q}</span>
        <span style={{
          width: 28, height: 28, borderRadius: "50%", flexShrink: 0,
          border: `1px solid ${open ? T.g500 : T.n200}`,
          background: open ? T.g500 : "transparent",
          color: open ? T.white : T.n400,
          display: "flex", alignItems: "center", justifyContent: "center",
          transition: "all .22s cubic-bezier(.4,0,.2,1)",
          transform: open ? "rotate(45deg)" : "none",
          fontSize: 18, fontWeight: 300, lineHeight: 1,
        }}>+</span>
      </button>
      <div style={{ overflow: "hidden", maxHeight: open ? 500 : 0, transition: "max-height .32s cubic-bezier(.4,0,.2,1)" }}>
        <p style={{ margin: "0 0 22px", fontSize: 15, color: T.n600, lineHeight: 1.8, paddingRight: 48, fontFamily: T.sans }}>{a}</p>
      </div>
    </div>
  );
}

function ServiceCard({ icon, label, desc, range, note, tags }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: "22px", borderRadius: 16,
        border: `1.5px solid ${hovered ? T.g200 : T.n150}`,
        background: hovered ? T.g50 : T.white,
        transition: "all .18s", display: "flex", flexDirection: "column", gap: 12,
      }}>
      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12 }}>
        <div style={{
          width: 40, height: 40, borderRadius: 11, flexShrink: 0,
          background: hovered ? T.g100 : T.n50,
          border: `1px solid ${hovered ? T.g200 : T.n150}`,
          display: "flex", alignItems: "center", justifyContent: "center",
          transition: "all .18s",
        }}>
          <Icon name={icon} size={17} color={hovered ? T.g600 : T.n400} strokeWidth={1.7} />
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontFamily: T.serif, fontSize: 17, fontWeight: 400, color: hovered ? T.g700 : T.n900, letterSpacing: "-0.02em", lineHeight: 1.1 }}>{range}</div>
          <div style={{ fontSize: 11, color: T.n400, marginTop: 2 }}>{note}</div>
        </div>
      </div>
      <div>
        <div style={{ fontSize: 14, fontWeight: 600, color: T.n900, marginBottom: 6, letterSpacing: "-0.01em" }}>{label}</div>
        <p style={{ fontSize: 13, color: T.n600, lineHeight: 1.7, margin: 0 }}>{desc}</p>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 4 }}>
        {tags.map((tag, i) => (
          <span key={i} style={{
            fontSize: 11, color: hovered ? T.g700 : T.n600,
            background: hovered ? T.g100 : T.n50,
            border: `1px solid ${hovered ? T.g200 : T.n150}`,
            borderRadius: 99, padding: "3px 10px", fontWeight: 500,
            transition: "all .18s",
          }}>{tag}</span>
        ))}
      </div>
    </div>
  );
}

function StepCard({ step, isLast }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ display: "flex", gap: 20, position: "relative" }}>
      {!isLast && (
        <div style={{
          position: "absolute", left: 23, top: 52, bottom: open ? -8 : -20,
          width: 1, background: `linear-gradient(to bottom, ${T.g200}, ${T.n100})`,
          transition: "bottom .3s",
        }} />
      )}
      <div style={{
        width: 48, height: 48, borderRadius: 14, flexShrink: 0, zIndex: 1,
        background: T.g50, border: `1.5px solid ${T.g100}`,
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        <Icon name={step.icon} size={20} color={T.g500} strokeWidth={1.6} />
      </div>
      <div style={{ flex: 1, paddingBottom: isLast ? 0 : 44 }}>
        <button onClick={() => setOpen(o => !o)} style={{
          width: "100%", background: "none", border: "none", cursor: "pointer",
          padding: 0, textAlign: "left", fontFamily: T.sans,
          display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12,
        }}>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: T.g500, letterSpacing: "0.1em", marginBottom: 5 }}>STEP {step.n}</div>
            <div style={{ fontFamily: T.serif, fontSize: "clamp(17px,2.5vw,21px)", fontWeight: 400, color: T.n900, letterSpacing: "-0.02em", lineHeight: 1.25 }}>{step.title}</div>
          </div>
          <span style={{
            width: 26, height: 26, borderRadius: "50%", flexShrink: 0, marginTop: 16,
            border: `1px solid ${open ? T.g500 : T.n200}`,
            background: open ? T.g500 : "transparent",
            color: open ? T.white : T.n400,
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 16, fontWeight: 300, lineHeight: 1,
            transition: "all .2s", transform: open ? "rotate(45deg)" : "none",
          }}>+</span>
        </button>
        <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.8, margin: "10px 0 0" }}>{step.desc}</p>
        <div style={{ overflow: "hidden", maxHeight: open ? 200 : 0, transition: "max-height .3s cubic-bezier(.4,0,.2,1)" }}>
          <div style={{ marginTop: 14, padding: "14px 16px", background: T.g50, borderRadius: 10, border: `1px solid ${T.g100}` }}>
            <p style={{ fontSize: 13, color: T.g700, lineHeight: 1.75, margin: 0 }}>{step.detail}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

function Testimonial({ name, area, service, rating, text }) {
  const initials = name.split(" ").map(w => w[0]).slice(0, 2).join("");
  const palette = [
    { bg: T.g50,     text: T.g700,    border: T.g100 },
    { bg: "#eff6ff", text: "#1d4ed8", border: "#bfdbfe" },
    { bg: "#fdf4ff", text: "#7e22ce", border: "#e9d5ff" },
  ];
  const c = palette[name.charCodeAt(0) % palette.length];
  return (
    <div style={{ padding: "24px", borderRadius: 16, border: `1px solid ${T.n150}`, background: T.white, display: "flex", flexDirection: "column", gap: 16 }}>
      <StarRating count={rating} />
      <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.85, margin: 0, fontStyle: "italic" }}>"{text}"</p>
      <div style={{ borderTop: `1px solid ${T.n100}`, paddingTop: 16, display: "flex", alignItems: "center", gap: 12 }}>
        <div style={{ width: 38, height: 38, borderRadius: "50%", background: c.bg, border: `1.5px solid ${c.border}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 600, color: c.text, flexShrink: 0 }}>{initials}</div>
        <div>
          <div style={{ fontSize: 13, fontWeight: 600, color: T.n900 }}>{name}</div>
          <div style={{ fontSize: 12, color: T.n400 }}>{service} · {area}</div>
        </div>
      </div>
    </div>
  );
}

/* ══ MAIN PAGE ══ */
export default function PhotographyPage() {
  useFonts();
  const navigate = useNavigate();
  const [location, setLocation] = useState("");
  const [locationFocused, setLocationFocused] = useState(false);

  const handleSearch = () => {
    const params = new URLSearchParams({ category: "photography" });
    if (location.trim()) params.set("location", location.trim());
    navigate(`/search?${params.toString()}`);
  };

  return (
    <div style={{ fontFamily: T.sans, background: T.white, minHeight: "100vh", color: T.n900, paddingBottom: 80 }}>
      <style>{`* { box-sizing: border-box; } ::-webkit-scrollbar { display: none; }`}</style>

      {/* ── Nav ── */}
      <div style={{ padding: "16px 24px", borderBottom: `1px solid ${T.n100}`, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <button onClick={() => navigate(-1)} style={{
          display: "inline-flex", alignItems: "center", gap: 6, background: "none",
          border: "none", cursor: "pointer", color: T.n400, fontSize: 13, fontFamily: T.sans, padding: 0,
        }}
          onMouseEnter={e => e.currentTarget.style.color = T.n800}
          onMouseLeave={e => e.currentTarget.style.color = T.n400}>
          <Icon name="ArrowLeft" size={14} strokeWidth={2} />
          Back
        </button>
        <button onClick={() => navigate("/become-a-pro")} style={{
          display: "inline-flex", alignItems: "center", gap: 6, background: "none",
          border: `1px solid ${T.n200}`, cursor: "pointer", color: T.n600,
          fontSize: 13, fontFamily: T.sans, padding: "8px 16px", borderRadius: 8, fontWeight: 500,
        }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = T.g400; e.currentTarget.style.color = T.g600; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = T.n200; e.currentTarget.style.color = T.n600; }}>
          <Icon name="Camera" size={13} strokeWidth={2} />
          Are you a photographer? Join free
        </button>
      </div>

      {/* ══ HERO ══ */}
      <div style={{ padding: "clamp(52px,7vw,88px) 20px clamp(44px,5vw,64px)", borderBottom: `1px solid ${T.n100}`, background: `linear-gradient(160deg, ${T.g50} 0%, ${T.white} 60%)` }}>
        <div style={{ maxWidth: 720, margin: "0 auto" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, color: T.g600, fontSize: 12, fontWeight: 600, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 22 }}>
            <Icon name="Camera" size={14} color={T.g500} strokeWidth={2.2} />
            Photography
          </div>
          <h1 style={{ fontFamily: T.serif, fontSize: "clamp(38px,7vw,68px)", fontWeight: 400, margin: "0 0 18px", lineHeight: 1.06, color: T.n900, letterSpacing: "-0.03em", maxWidth: 640 }}>
            Verified photographers<br />
            <em style={{ fontStyle: "italic", color: T.g600 }}>wherever you need them</em>
          </h1>
          <p style={{ fontSize: "clamp(15px,2vw,17px)", color: T.n600, lineHeight: 1.8, margin: "0 0 36px", maxWidth: 520 }}>
            Book professional photographers for weddings, portraits, corporate events, product shoots, and content creation. Browse real portfolios, read verified reviews, and book with confidence.
          </p>

          {/* Search bar */}
          <div style={{ display: "flex", gap: 10, maxWidth: 520, flexWrap: "wrap" }}>
            <div style={{ position: "relative", flex: 1, minWidth: 200 }}>
              <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}>
                <Icon name="MapPin" size={16} color={T.n400} strokeWidth={1.8} />
              </span>
              <input
                value={location}
                onChange={e => setLocation(e.target.value)}
                onFocus={() => setLocationFocused(true)}
                onBlur={() => setLocationFocused(false)}
                onKeyDown={e => e.key === "Enter" && handleSearch()}
                placeholder="Your estate or area..."
                style={{
                  width: "100%", padding: "15px 16px 15px 42px",
                  border: `1px solid ${locationFocused ? T.g500 : T.n200}`,
                  borderRadius: 11, fontSize: 14, outline: "none",
                  background: T.white, color: T.n900, fontFamily: T.sans,
                  boxShadow: locationFocused ? `0 0 0 4px ${T.g100}` : "0 1px 4px rgba(0,0,0,.06)",
                  transition: "all .18s",
                }} />
            </div>
            <button onClick={handleSearch} style={{
              padding: "15px 28px", background: T.g500, color: T.white,
              border: "none", borderRadius: 11, fontSize: 14, fontWeight: 600,
              cursor: "pointer", fontFamily: T.sans,
              display: "inline-flex", alignItems: "center", gap: 8, whiteSpace: "nowrap",
            }}
              onMouseEnter={e => e.currentTarget.style.background = T.g600}
              onMouseLeave={e => e.currentTarget.style.background = T.g500}>
              <Icon name="Search" size={15} color={T.white} strokeWidth={2} />
              Find a photographer
            </button>
          </div>
          <p style={{ fontSize: 12, color: T.n400, margin: "12px 0 0" }}>
            Available in Nairobi, Mombasa, Kisumu, Nakuru and Eldoret
          </p>
        </div>
      </div>

      {/* ══ TRUST STRIP ══ */}
      <div style={{ borderBottom: `1px solid ${T.n100}`, padding: "0 20px" }}>
        <div style={{ maxWidth: 720, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))" }}>
          {[
            { icon: "BadgeCheck",  label: "Verified photographers with real portfolio previews" },
            { icon: "Star",        label: "Reviews only from verified, completed shoots" },
            { icon: "ShieldCheck", label: "Payment held until you confirm image delivery" },
          ].map(({ icon, label }, i) => (
            <div key={i} style={{ padding: "20px", display: "flex", alignItems: "center", gap: 11, borderRight: i < 2 ? `1px solid ${T.n100}` : "none" }}>
              <Icon name={icon} size={17} color={T.g500} strokeWidth={1.5} />
              <span style={{ fontSize: 13, color: T.n600, lineHeight: 1.4 }}>{label}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{ maxWidth: 720, margin: "0 auto", padding: "0 20px" }}>

        {/* ══ SUB-SERVICES ══ */}
        <div style={{ paddingTop: "clamp(48px,7vw,72px)", marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>Services available</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Every type of shoot,<br />
            <em style={{ fontStyle: "italic", color: T.g600 }}>at your location</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 28px", lineHeight: 1.65 }}>
            JiraniApp photographers cover weddings, portraits, corporate events, product photography, social media content, and videography. Each Pro lists their specific specialities, equipment, and pricing so you know exactly what you are booking.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 14 }}>
            {SUB_SERVICES.map((s, i) => <ServiceCard key={i} {...s} />)}
          </div>
        </div>

        {/* ══ HOW IT WORKS ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>How it works</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            From search to final gallery in <em style={{ fontStyle: "italic", color: T.g600 }}>five steps</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 32px", lineHeight: 1.65 }}>
            Tap any step to see what actually happens at that stage. Photography has a few more moving parts than most services, so knowing each step before you book makes everything smoother.
          </p>
          <div style={{ paddingLeft: 4 }}>
            {HOW_IT_WORKS.map((step, i) => (
              <StepCard key={i} step={step} isLast={i === HOW_IT_WORKS.length - 1} />
            ))}
          </div>
        </div>

        {/* ══ TRUST SECTION ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)", padding: "clamp(28px,5vw,44px)", borderRadius: 20, background: T.g50, border: `1px solid ${T.g100}` }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>Your protection</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(24px,4vw,34px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.2 }}>
            Booking a photographer should feel<br />
            <em style={{ fontStyle: "italic", color: T.g600 }}>completely safe</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n600, lineHeight: 1.75, margin: "0 0 28px" }}>
            Here is exactly how JiraniApp protects you from the moment you book to the moment your final images land in your inbox.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 20 }}>
            {TRUST_POINTS.map((pt, i) => (
              <div key={i} style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
                <div style={{ width: 38, height: 38, borderRadius: 10, background: T.white, border: `1px solid ${T.g100}`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <Icon name={pt.icon} size={16} color={T.g500} strokeWidth={1.7} />
                </div>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: T.n900, marginBottom: 6, letterSpacing: "-0.01em" }}>{pt.title}</div>
                  <p style={{ fontSize: 13, color: T.g700, lineHeight: 1.75, margin: 0 }}>{pt.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ══ TESTIMONIALS ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>Client stories</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            What clients say after their <em style={{ fontStyle: "italic", color: T.g600 }}>shoot</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 24px", lineHeight: 1.65 }}>
            Every review below is from a verified booking on JiraniApp. No editorial. No incentivised reviews.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(290px, 1fr))", gap: 14 }}>
            {TESTIMONIALS.map((t, i) => <Testimonial key={i} {...t} />)}
          </div>
        </div>

        {/* ══ FAQ ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>Common questions</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 4px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Before you <em style={{ fontStyle: "italic", color: T.g600 }}>book a photographer</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 8px", lineHeight: 1.65 }}>
            Everything clients ask us most often about photography bookings on JiraniApp.
          </p>
          <div style={{ marginTop: 8 }}>
            {FAQS.map((item, i) => <FaqItem key={i} {...item} />)}
          </div>
        </div>

        {/* ══ FOOTER CTA ══ */}
        <div style={{ padding: "clamp(36px,5vw,56px)", borderRadius: 20, border: `1px solid ${T.n150}`, textAlign: "center", background: T.n50, marginBottom: 20 }}>
          <div style={{ width: 52, height: 52, borderRadius: 14, background: T.g50, border: `1.5px solid ${T.g200}`, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
            <Icon name="Camera" size={22} color={T.g500} strokeWidth={1.6} />
          </div>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,38px)", fontWeight: 400, color: T.n900, margin: "0 0 12px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Ready to find your<br />
            <em style={{ fontStyle: "italic", color: T.g600 }}>photographer?</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 auto 32px", lineHeight: 1.75, maxWidth: 420 }}>
            Browse verified photographers near you, view their real portfolios, and book with full payment protection. Every shot, every session, backed by JiraniApp.
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <button onClick={handleSearch} style={{
              padding: "14px 32px", background: T.g500, color: T.white,
              border: "none", borderRadius: 11, fontSize: 15, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
              display: "inline-flex", alignItems: "center", gap: 8,
            }}
              onMouseEnter={e => e.currentTarget.style.background = T.g600}
              onMouseLeave={e => e.currentTarget.style.background = T.g500}>
              Find a photographer near me
              <Icon name="ArrowRight" size={15} color={T.white} strokeWidth={2} />
            </button>
            <button onClick={() => navigate("/how-it-works")} style={{
              padding: "14px 28px", background: "transparent", color: T.n700,
              border: `1.5px solid ${T.n200}`, borderRadius: 11, fontSize: 15, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
            }}
              onMouseEnter={e => e.currentTarget.style.borderColor = T.n400}
              onMouseLeave={e => e.currentTarget.style.borderColor = T.n200}>
              How JiraniApp works
            </button>
          </div>
          <p style={{ fontSize: 12, color: T.n300, margin: "20px 0 0" }}>
            Free to browse · No booking fees · Pay only when you confirm
          </p>
        </div>

      </div>
    </div>
  );
}